import * as React from 'react';
import { Radio } from 'antd';
import { NiRadioValue } from '.';
import { RadioGroupProps } from 'antd/lib/radio';

const RadioGroup = Radio.Group;

export type NiRadioProps = RadioGroupProps & {
  keyValue: NiRadioValue[];
  radioStyle?: any;
};

export type NiRadioState = {};

export class NiRadio extends React.Component<NiRadioProps, NiRadioState> {
  render() {
    const { keyValue, radioStyle } = this.props;

    return (
      keyValue && (
        <RadioGroup {...this.props}>
          {keyValue.map((item: NiRadioValue) => {
            return (
              <Radio
                style={radioStyle || {}}
                value={item.key}
                key={`radio-${item.key}`}
                disabled={item.disabled}
              >
                {item.value}
              </Radio>
            );
          })}
        </RadioGroup>
      )
    );
  }
}

export type NiBooleanRadioProps = {
  value: boolean;
  onChange: (nextValue: boolean) => void;
  trueWord: string;
  falseWord: string;
  trueFirst?: boolean;
  style?: React.CSSProperties
  disabled?: boolean;
};

export class NiBooleanRadio extends React.Component<NiBooleanRadioProps> {

  render() {
    const { value = false, onChange, trueWord, falseWord, trueFirst = false, style, disabled } = this.props;
    const keyValue = trueFirst ? [
      { key: true, value: trueWord },
      { key: false, value: falseWord }
    ] : [
      { key: false, value: falseWord },
      { key: true, value: trueWord }
    ];

    return <NiRadio
      disabled={disabled}
      value={value}
      onChange={(e: any) => {
        onChange(e.target.value);
      }}
      style={style}
      keyValue={keyValue}
    />;
  }
}
